export function mondayOf(d = new Date()) {
  const dt = new Date(d);
  dt.setDate(dt.getDate() - ((dt.getDay() + 6) % 7));
  return dt.toISOString().slice(0, 10);
}

export function weekLabel(ws) {
  const s = new Date(ws + "T12:00:00");
  const e = new Date(s); e.setDate(e.getDate() + 6);
  const f = (x) => x.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `${f(s)} – ${f(e)}`;
}
